import * as yup from 'yup';
import { ALPHA_NUMERIC_DASH_UNDERSCORE_PATTERN } from '../../../constants/validation';
import { ClinicalTrialUpdateType } from '@dynamika-shared/types/clinicalTrials';

export const schema = yup.object().shape({
  name: yup
    .string()
    .max(320, 'Name should not exceed 320 characters')
    .required('Name is required'),
  code: yup
    .string()
    .required('CT Code is required')
    .matches(
      ALPHA_NUMERIC_DASH_UNDERSCORE_PATTERN,
      'Code should contain only letters, digits, "-" or "_"'
    ),
  sponsorId: yup.string().required('Sponsor ID is required'),
  dataStorageLocationId: yup
    .string()
    .required('Data storage location ID is required'),
  description: yup
    .string()
    .max(700, 'Description should not exceed 700 characters'),
  iagStudyEmail: yup
    .string()
    .nullable()
    .transform(value => (value ? value.trim() : null))
    .email('IAG study email is not valid'),
  dashboardUrl: yup
    .string()
    .nullable()
    .transform(value => (value ? value.trim() : null))
    .url('Dashboard Url is not valid'),
  ctGovLink: yup
    .string()
    .nullable()
    .transform(value => (value ? value.trim() : null))
    .url('CT Gov Link is not valid'),
  eudraCt: yup
    .string()
    .nullable()
    .transform(value => (value ? value.trim() : null))
    .url('Eudra CT is not valid'),
  phase: yup.string().required('Phase is required'),
  therapeuticArea: yup.string().required('Therapeutic area is required'),
  disease: yup.string().required('Disease is required'),
  drugMolecule: yup.string().nullable().max(320),
  dicomViewerVersion: yup.string().required('OHIF Version is required'),
  startDate: yup.string().required('Start date is required'),
  endDate: yup.string().required('End date is required'),
  firstPatientVisit: yup
    .string()
    .required('Last subject visit date is required'),
  lastPatientVisit: yup
    .string()
    .required('Last subject visit date is required'),
  siteHypothesis: yup
    .number()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === '' ? null : value;
    })
    .required('Number of Sites is required')
    .min(1, 'Number of Sites must be at least 1')
    .max(9999, 'Number of Sites must be at most 9999'),
  patientHypothesis: yup
    .number()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === '' ? null : value;
    })
    .required('Number of  Subjects is required')
    .min(1, 'Number of  Subjects must be at least 1')
    .max(99999, 'Number of  Subjects must be at most 99999'),
  visitHypothesis: yup
    .number()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === '' ? null : value;
    })
    .required('Number of Visits is required')
    .min(1, 'Number of Visits must be at least 1')
    .max(9999, 'Number of Visits must be at most 9999'),
}) as yup.ObjectSchema<ClinicalTrialUpdateType>;
